var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: "Performance de Entregas", loading: _vm.loading } },
    [
      _c(
        "sc-grid",
        {
          attrs: {
            name: _vm.$options.name,
            data: _vm.reportData.entries,
            total: _vm.reportData.total,
            "default-filters": _vm.defaultFilters,
            "default-sort-column": "id",
            "default-sort-direction": "ascending"
          },
          on: {
            submit: _vm.config,
            pagination: _vm.config,
            sorting: _vm.config
          },
          scopedSlots: _vm._u([
            {
              key: "filters",
              fn: function(ref) {
                var filters = ref.filters
                return [
                  _c("sc-report-performance-filters", {
                    attrs: { filters: filters }
                  })
                ]
              }
            },
            {
              key: "table-columns",
              fn: function(ref) {
                var props = ref.props
                return [
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "order_number",
                        label: "Número do Pedido",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.order_number) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "invoices",
                        label: "Número da Nota",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.listInvoiceNumbers(props.row.invoices)) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "shipping_first_name",
                        centered: false,
                        label: "Nome do Cliente",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.getFullName(
                              props.row.shipping_first_name,
                              props.row.shipping_last_name
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "logistic_provider_name",
                        centered: false,
                        label: "Provedor Logístico",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.logistic_provider_name) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        centered: false,
                        field: "delivery_method_name",
                        label: "Método de Entrega",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.delivery_method_name) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "estimated_delivery_date_iso",
                        label: "Data de Entrega Estimada Cliente",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("date")(
                              props.row.estimated_delivery_date_iso,
                              "DD/MM/YYYY"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "estimated_delivery_date_lp_iso",
                        label: "Data de Entrega Estimada Transp.",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("date")(
                              props.row.estimated_delivery_date_lp_iso,
                              "DD/MM/YYYY"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "delivered_date_iso",
                        label: "Data de entrega",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("date")(
                              props.row.delivered_date_iso,
                              "DD/MM/YYYY"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        centered: false,
                        field: "on_time_localized",
                        label: "Performance Cliente",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.on_time_localized) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        centered: false,
                        field: "on_time_lp_localized",
                        label: "Performance Transp.",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.on_time_lp_localized) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "shipping_state",
                        label: "Estado",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.shipping_state) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "created_at_date_time_iso",
                        label: "Criado em",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("date")(
                              props.row.created_at_date_time_iso,
                              "DD/MM/YYYY"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _vm.reportData.total
            ? _c(
                "template",
                { attrs: { slot: "after-filters" }, slot: "after-filters" },
                [
                  _c(
                    "div",
                    { staticClass: "box" },
                    [_c("sc-report-performance-chart")],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.reportData.total
            ? _c(
                "template",
                { attrs: { slot: "before-table" }, slot: "before-table" },
                [
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _c("sc-button", {
                        attrs: {
                          theme: "primary",
                          loading: _vm.exportLoading,
                          text: "Exportar para o Excel",
                          icon: "file-excel"
                        },
                        on: {
                          click: function($event) {
                            _vm.exportReport(_vm.reportConfig)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e45fd88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e45fd88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/performance/PageReportPerformance.vue
// module id = null
// module chunks = 